import React, { useState } from "react";
import { Link } from "react-router-dom";
import { postForm } from "../utils/formApi";

const endpoint = process.env.REACT_APP_CONTACT_API_URL;
const enabled = process.env.REACT_APP_CONTACT_FORM_ENABLED === "true" && Boolean(endpoint);

const initialForm = {
  name: "",
  email: "",
  company: "",
  subject: "Birdwatcher project enquiry",
  message: "",
  privacy: false,
  website: "",
};

export default function ContactPage() {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState("idle");

  function updateField(event) {
    const { name, value, type, checked } = event.target;
    setForm((current) => ({ ...current, [name]: type === "checkbox" ? checked : value }));
  }

  async function handleSubmit(event) {
    event.preventDefault();
    if (!enabled || !form.privacy) return;

    if (form.website) {
      setStatus("success");
      return;
    }

    setStatus("sending");
    try {
      await postForm(endpoint, {
        name: form.name.trim(),
        email: form.email.trim(),
        company: form.company.trim(),
        subject: form.subject,
        message: form.message.trim(),
        privacyAccepted: true,
        source: "birdwatcher-website-contact",
        submittedAt: new Date().toISOString(),
      });
      setForm(initialForm);
      setStatus("success");
    } catch (error) {
      console.error("Contact form failed", error);
      setStatus("error");
    }
  }

  return (
    <div className="page legal-page">
      <section className="page-section legal-hero">
        <p className="eyebrow">Agroadvisor · Contact</p>
        <h1>Talk to the team.</h1>
        <p className="hero-intro">For Birdwatcher deployments, research collaboration or a private demo, use the contact route that works best for you.</p>
      </section>

      <section className="page-section contact-layout compact-section">
        <div className="contact-direct-card">
          <span className="section-label">Direct contact</span>
          <h2>Call or email us</h2>
          <p>Scan the QR code on a phone to open the Agroadvisor mobile number directly, or use email for a written enquiry.</p>
          <a className="contact-email" href="tel:+36301634341">+36 30 163 4341</a>
          <a className="contact-email" href="mailto:info@agroadvisor.hu?subject=Birdwatcher%20project%20enquiry">info@agroadvisor.hu</a>
          <a className="qr-link" href="tel:+36301634341" aria-label="Call Agroadvisor">
            <img src="/contact-phone-qr.svg" alt="QR code for calling Agroadvisor at +36 30 163 4341" />
            <span>Scan to call</span>
          </a>
          <div className="contact-address">
            <strong>Agroadviser Solutions Kft.</strong>
            <span>3700 Kazincbarcika, Rózsa út 57.</span>
            <span>Hungary</span>
          </div>
        </div>

        <div className="contact-form-card">
          <div className="form-card-head">
            <div>
              <span className="section-label">Contact form</span>
              <h2>Send an enquiry</h2>
            </div>
            <span className={`feature-status ${enabled ? "is-live" : "is-disabled"}`}>{enabled ? "Online" : "AWS connection pending"}</span>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-grid">
              <label>
                <span>Name</span>
                <input name="name" value={form.name} onChange={updateField} autoComplete="name" disabled={!enabled || status === "sending"} required />
              </label>
              <label>
                <span>Email</span>
                <input name="email" type="email" value={form.email} onChange={updateField} autoComplete="email" disabled={!enabled || status === "sending"} required />
              </label>
              <label>
                <span>Company <small>optional</small></span>
                <input name="company" value={form.company} onChange={updateField} autoComplete="organization" disabled={!enabled || status === "sending"} />
              </label>
              <label>
                <span>Topic</span>
                <select name="subject" value={form.subject} onChange={updateField} disabled={!enabled || status === "sending"}>
                  <option>Birdwatcher project enquiry</option>
                  <option>Private demo</option>
                  <option>Research collaboration</option>
                  <option>Deployment and integration</option>
                  <option>Privacy or data protection question</option>
                </select>
              </label>
            </div>

            <label className="honeypot" aria-hidden="true">
              Website
              <input name="website" tabIndex="-1" autoComplete="off" value={form.website} onChange={updateField} disabled={!enabled} />
            </label>

            <label>
              <span>Message</span>
              <textarea name="message" rows="7" value={form.message} onChange={updateField} disabled={!enabled || status === "sending"} required />
            </label>

            <label className="consent-line contact-consent">
              <input name="privacy" type="checkbox" checked={form.privacy} onChange={updateField} disabled={!enabled || status === "sending"} required />
              <span>I have read the <Link to="/privacy">privacy and data protection notice</Link> and understand how my enquiry will be processed.</span>
            </label>

            <div className="form-submit-row">
              <button className="button button-primary" type="submit" disabled={!enabled || !form.privacy || status === "sending"}>
                {enabled ? (status === "sending" ? "Sending…" : "Send enquiry") : "Form not connected yet"}
              </button>
              {!enabled && <small>The form is intentionally disabled until the AWS endpoint is configured. Phone and email remain available.</small>}
            </div>
            {status === "success" && <p className="form-feedback form-success">Thank you. Your message has been submitted.</p>}
            {status === "error" && <p className="form-feedback form-error">The request could not be submitted. Please contact us directly.</p>}
          </form>
        </div>
      </section>
    </div>
  );
}
